import Whatsapp from './Whatsapp';
import Keyfeatures from './Keyfeatures';
import HowItWorks from './HowItWorks';
import AiExpertTutor from './AiExterTutor';
import WhySchoolLoveAiPowred from './WhySchoolLoveAiPowred';
import LandingPageComponentWrapper from '../components/LandingPageComponentWrapper';

const componentsList = [
    { component: <Whatsapp />, bgColor: "bg-[#ECECF7]", id: "whatsapp-Whatsapp" },
    { component: <Keyfeatures />, bgColor: "", id: "whatsapp-Keyfeatures" },
    { component: <HowItWorks />, bgColor: "bg-[#ECECF7]", id: "whatsapp-HowItWorks" },
    { component: <AiExpertTutor />, bgColor: "", id: "whatsapp-AiExpertTutor" },
    { component: <WhySchoolLoveAiPowred />, bgColor: "bg-[#ECECF7]", id: "whatsapp-WhySchoolLoveAiPowred" },
]

const AvatarWhatsapp = () => {
    return <div className="bg-[#FCFAFF]  mt-40" style={{
        position: "relative",
        zIndex: 1,
        // backgroundColor: "transparent",
    }}>
        {componentsList.map((element: any, index) => (
            <div
                key={"components" + index}
                id={element?.id}
            // ref={(el) => (sectionRefs.current[index] = el) as any}
            >
                <LandingPageComponentWrapper bg={element?.bgColor} isFlex1={element?.isFlex1}>
                    {element?.component}
                </LandingPageComponentWrapper>
            </div>))}
    </div>
}

export default AvatarWhatsapp;